module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue6.0e8af1a7.jpg";